<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <v-chip
    v-if="status"
    :color="chipColor"
    :text-color="textColor"
    label
    class="benefit-status-chip font-weight-medium"
  >
    <v-icon left small class="benefit-status-chip__icon">
      {{ chipIcon }}
    </v-icon>
    {{ chipLabel }}
  </v-chip>
  <span v-else class="text--disabled">—</span>
</template>

<script>
import { mdiCheckCircleOutline, mdiClockOutline, mdiCloseCircleOutline } from '@mdi/js'

const STATUS_MAP = {
  pending: {
    label: 'На проверке',
    color: 'warning',
    icon: mdiClockOutline,
  },
  approved: {
    label: 'Одобрена',
    color: 'success',
    icon: mdiCheckCircleOutline,
  },
  rejected: {
    label: 'Отклонена',
    color: 'error',
    icon: mdiCloseCircleOutline,
  },
  active: {
    label: 'Активна',
    color: 'success',
    icon: mdiCheckCircleOutline,
  },
  inactive: {
    label: 'Неактивна',
    color: 'warning',
    icon: mdiClockOutline,
  },
  expired: {
    label: 'Истекла',
    color: 'error',
    icon: mdiCloseCircleOutline,
  },
}

export default {
  name: 'BenefitStatusChip',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    meta() {
      return STATUS_MAP[this.status] || { label: this.status, color: 'default', icon: '' }
    },
    chipColor() {
      return this.meta.color
    },
    chipLabel() {
      return this.meta.label
    },
    chipIcon() {
      return this.meta.icon
    },
    textColor() {
      const map = { warning: 'white', success: 'white', error: 'white' }
      return map[this.meta.color] || undefined
    },
  },
}
</script>
